import React, { useState, useCallback, useMemo } from 'react'

import { Run, UserPrivate } from '@pollination-solutions/pollination-sdk'

import { APIClient, RunDetails } from 'pollination-react-io'
import { FileCardProps } from 'pollination-react-io/build/RunDetails/Cards/FileCard'
import { FolderCardProps } from 'pollination-react-io/build/RunDetails/Cards/FolderCard'
import { PreviewWindow } from 'components/Folder/PreviewWindow'

interface RunPageDetailsProps {
  accountName: string
  projectName: string
  run?: Run
  authUser?: UserPrivate
  client?: APIClient
  getFolderCard?: (card: FolderCardProps) => any
  isCloud?: boolean
}

interface HoverObject {
  expand: boolean
  close: boolean
}

export const RunPageDetails: React.FunctionComponent<RunPageDetailsProps> = ({
  accountName,
  projectName,
  run,
  authUser,
  client,
  getFolderCard,
  isCloud
}) => {
  const [currCard, setCurrCard] = useState<FileCardProps>()

  const getFileCardHandler = useCallback((card: FileCardProps) => {
    setCurrCard(card)
  }, [currCard])

  const fileMeta = useMemo(() => {
    if (!currCard) return
    return { 
      file_name: currCard?.previewName ?? currCard.path.split('/').reverse()[0],
      file_type: currCard?.previewName?.split('.')[1] ?? 'unknown',
      key: currCard.path, 
    }
  }, [currCard])

  return (
    <>
      {run && currCard &&
        fileMeta && <PreviewWindow blob={currCard.previewFile as Blob} 
        isCloud={isCloud}
        file={fileMeta} url={fileMeta.key} onClose={() => setCurrCard(undefined)} />}
      {run && client && authUser && <div style={{ margin: '10px 0 0 0' }}>
        <RunDetails
          style={{ backgroundColor: '#fff' }}
          projectName={projectName}
          projectOwner={accountName}
          getFileCard={getFileCardHandler}
          getFolderCard={getFolderCard}
          // @ts-ignore
          run={run}
          // @ts-ignore
          client={client}
          isCloud={isCloud}/>
      </div>}
    </>
  )
}